import PropTypes from 'prop-types';
import React, { Fragment, Component } from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { defaultRoute } from 'routes';
import { Redirect } from 'react-router-dom';

import {
  DateFilter,
  ShipmentFilters,
  ShipperFilter,
  RouteFilter,
  VehicleTypeFilter,
  CancelledFilter,
} from 'components/ShipmentFilters';

import ShipperOrderTable from 'modules/shipper-order/Table';

import {
  openShipperOrderDetail,
  fetchInitialShipperOrdersPage,
  fetchNextShipperOrdersPage,
  queuedMounted,
  queuedUnmounted,
  visibilityChange,
} from 'redux/modules/shipper-orders/effects';

import { filterOrders } from 'redux/modules/queued/effects';

import {
  getGroupedByDate,
  getGroupedByDateTotals,
  getNextPageLink,
  getIsNextPageLoading,
} from 'redux/modules/shipper-orders/selectors';

import { getFilters, isQueuedReady } from 'redux/modules/queued/selectors';

import JourneyMap from 'modules/journey/map/Modal';

import { StyledLoading, StyledNotFound } from './styled';
import { IS_TENANT } from 'tenant/config';

const actionCreators = {
  filterOrders,
  queuedMounted,
  queuedUnmounted,
  openShipperOrderDetail,
  fetchInitialShipperOrdersPage,
  fetchNextShipperOrdersPage,
  visibilityChange,
};

class QueuedList extends Component {
  constructor(props) {
    super(props);
    this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
  }

  handleRowClick = (_, id) => {
    const { openShipperOrderDetail, match } = this.props;
    const { url } = match;
    openShipperOrderDetail({ url, id });
  };

  handleVisibilityChange() {
    const { visibilityChange } = this.props;
    visibilityChange(!document.hidden);
  }

  componentDidMount() {
    const { filters, queuedMounted, fetchInitialShipperOrdersPage } = this.props;
    fetchInitialShipperOrdersPage(filters);
    queuedMounted(filters);
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
  }

  componentWillUnmount() {
    const { filters, queuedUnmounted } = this.props;
    queuedUnmounted(filters);
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
  }

  handleLoadMore = (page) => {
    this.props.fetchNextShipperOrdersPage(this.props.nextPageLink);
  };

  render() {
    const { totalsByDate, groupByDate, filters, filterOrders, ready, intl, fetchingNextPage } =
      this.props;

    const t = intl.messages.containers.QueuedOrders;

    const hasValues = !!Object.keys(groupByDate).length;

    // if tenant tries to access this route user will be redirected to default route
    // this is because tenant can go to /quequed/15 but not to /quequed
    // tenant can see queued detail but not queued list
    if (IS_TENANT) return <Redirect to={defaultRoute} />;

    return (
      <Fragment>
        <ShipmentFilters
          status={filters}
          onChangeFilter={filterOrders}
          rows={[
            [<DateFilter grow showCalendar={true} totals={totalsByDate} />, <RouteFilter />],
            [<ShipperFilter />, <CancelledFilter grow />, <VehicleTypeFilter />],
          ]}
        />

        {ready && (
          <ShipperOrderTable
            group={groupByDate}
            onRowClick={this.handleRowClick}
            onLoadMore={this.handleLoadMore}
            hasMore={!!this.props.nextPageLink && !fetchingNextPage}
          />
        )}

        {ready && !hasValues && <StyledNotFound>{t.no_orders}</StyledNotFound>}
        {!ready && <StyledLoading />}
        {fetchingNextPage && <StyledLoading />}

        <JourneyMap />
      </Fragment>
    );
  }
}

QueuedList.propTypes = {
  filters: PropTypes.object,
  filterOrders: PropTypes.func,
  match: PropTypes.object,
  intl: PropTypes.object,
  groupByDate: PropTypes.object,
  totalsByDate: PropTypes.object,
  openShipperOrderDetail: PropTypes.func,
  fetchInitialShipperOrdersPage: PropTypes.func,
  fetchNextShipperOrdersPage: PropTypes.func,
  ready: PropTypes.bool,
  nextPageLink: PropTypes.string.isRequired,
  queuedMounted: PropTypes.func,
  queuedUnmounted: PropTypes.func,
};

export default injectIntl(
  connect((state) => {
    const filters = getFilters(state);
    return {
      ready: isQueuedReady(state),
      fetchingNextPage: getIsNextPageLoading(state),
      filters,
      groupByDate: getGroupedByDate(state),
      totalsByDate: getGroupedByDateTotals(state),
      nextPageLink: getNextPageLink(state),
    };
  }, actionCreators)(QueuedList)
);
